// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oOkm","delete":"styles_delete__1ViZ8","update":"styles_update__2SzuZ","add":"styles_add__S_Gch"};